// Exact venue names only: roving clubs must never inherit their usual venue.
// Sources: https://www.nypl.org/locations/125th-street and
// https://www.symphonyspace.org/your-visit/accessibility (Thalia entrance).
const COMMUNITY_ADDRESSES = {
  // https://www.freddysbar.com/inquiries
  'Freddy’s Bar and Backroom, South Slope': '627 5th Avenue, Brooklyn, NY 11215',
  // https://thedittybar.squarespace.com/
  'The Ditty, Astoria': '35-03 Ditmars Boulevard, Astoria, NY 11105',
  // https://www.wildeastbrewing.com/
  'Wild East Brewing Co, Gowanus': '623 Sackett Street, Brooklyn, NY 11217',
  // https://www.zerovisioncinema.com/events/68
  'SingleCut Beersmiths, Astoria': '19-33 37th Street, Astoria, NY 11105',
  // https://www.medusaartstudios.com/contact-us
  'Medusa Art Studio & Events, Astoria': '18-14 Astoria Boulevard, Astoria, NY 11102',
  // Organizer's November announcement: https://www.screamscene.net/
  'Clara’s Gramercy, Gramercy Park': '393 Second Avenue, New York, NY',

  'NYPL 125th Street Library': '224 East 125th Street, New York, NY 10035',
  'Leonard Nimoy Thalia at Symphony Space': '250 West 95th Street, New York, NY 10025',
};

export function screeningAddress(showtime, fixedVenueAddress) {
  return COMMUNITY_ADDRESSES[showtime.theater] || fixedVenueAddress || null;
}

function publicUrl(value) {
  try {
    const url = new URL(value);
    return ['https:', 'http:'].includes(url.protocol) ? url.href : null;
  } catch { return null; }
}

export function screeningSchema(showtime, movie, options = {}) {
  const address = screeningAddress(showtime, options.address);
  // Don't assert rich-event eligibility when the actual location is unresolved.
  if (!address || !showtime.theater || showtime.isBlocked || !Number.isFinite(Date.parse(showtime.start_at))) return null;
  const title = movie?.title || showtime.cinema_movie_title;
  if (!title) return null;
  const booking = publicUrl(options.bookingUrl || showtime.booking_link);
  const image = publicUrl(movie?.poster_path);
  const parts = address.match(/^(.+), ([^,]+), NY (\d{5})$/);
  const postalAddress = parts
    ? {'@type':'PostalAddress', streetAddress:parts[1], addressLocality:parts[2], addressRegion:'NY', postalCode:parts[3], addressCountry:'US'}
    : {'@type':'PostalAddress', name:address, addressCountry:'US'};
  return {
    '@context': 'https://schema.org',
    '@type': 'ScreeningEvent',
    name: `${title} Screening`,
    startDate: showtime.start_at,
    ...(options.url && {url:options.url}),
    location: {'@type':'Place', name:showtime.theater, address:postalAddress},
    ...(movie?.synopsis && {description:movie.synopsis}),
    ...(image && {image}),
    ...(options.workPresented && {workPresented:options.workPresented}),
    ...(booking && {offers:{
      '@type':'Offer', url:booking,
      // A ticket link alone says nothing about available seats or ticket price.
      ...(showtime.sold_out === true && {availability:'https://schema.org/SoldOut'}),
    }}),
  };
}
